import { RouteComponentProps, StaticContext } from 'react-router';

export enum INTEGRATIONS_CATEGORIES {
  COMMUNICATIONS = 'Communications',
  CRM = 'CRM',
  MARKETING = 'Marketing',
  SOCIAL = 'Social',
}

export enum CDS_CATEGORIES {
  CONTENT = 'Content',
  DATA = 'Data',
  INVENTORY = 'Inventory',
  VEHICLE_PRESENTATION = 'Vehicle Presentation',
  FINANCE = 'Finance',
}

export enum DISCOVER_BY_FILTERS {
  FREE_TRIAL = 'Free Trial',
  FEATURED = 'Featured',
  NEWEST = 'Newest',
}

export enum INTEGRATIONS {
  SALESFORCE = 'Salesforce',
  ELEMENT_451 = 'Element451',
  GMAIL = 'Gmail',
  LINKEDIN = 'LinkedIn',
  OFFICE_365 = 'Office 365',
  OUTLOOK = 'Outlook',
  ZOOM = 'Zoom',
  IOS = 'iOS',
  ANDROID = 'Android',
  FACEBOOK = 'Facebook',
  YOUTUBE = 'YouTube',
  DEALERSOCKET = 'DealerSocket',
  CDK = 'CDK',
  IPACKET = 'iPacket',
  PROMAX = 'ProMax',
  TMS = 'TMS',
  EDEALER = 'Edealer',
  AUTO_SWEET = 'AutoSweet',
  PREDIAN = 'Predian',
  DEALER_INSPIRE = 'DealerInspire',
  HOMENET = 'HomeNet',
  AUTOMINER = 'Autominer',
  VAUTO = 'VAuto',
  DEALERSLINK = 'Dealerslink',
  ACV_MAX = 'ACV MAX',
  AUTO_REVOLUTION = 'Auto Revolution',
  DEALER_CENTER = 'Dealer Center',
  VIN_SULUTIONS = 'VinSolutions',
  VIN_CUE = 'VinCue',
  WHEELS_TV = 'WheelsTV',
  DEALER_CLOUD = 'dealer.cloud',
  DEALER_COM = 'dealer.com',
  CREDIT700 = '700Credit',
  LESA = 'Lesa',
  VINMOTION = 'VinMotion',
  DEALER_CAR_SEARCH = 'Dealer Car Search',
  CARS_FOR_SALE = 'Cars For Sale',
  JD_POWER = 'J.D. Power',
  AUTO_VERIFY = 'AutoVerify',
  INVENTORY_PLUS = 'Inventory+',
  MOMENTUM = 'Momentum',
  NETLOOK = 'NetLook',
  DEALER_EPROCESS = 'Dealer eProcess',
  DEALERCUE = 'DealerCue',
  ASTRAWEB = 'AstraWeb',
  DEALERSYNC = 'DealerSync',
  SINCRO = 'Sincro',
  AGENCY_360 = '360.Agency',
  CARPRAZE = 'Carpraze',
  DEALPACK = 'DealPack',
  AUTOTRADER = 'AutoTrader',
  AUTO_VISION = 'AutoVision',
  NEXTEPPE = 'Nexteppe',
  PODIUM = 'Podium',
}

export enum INTEGRATION_BC_CHANNELS {
  PODIUM = 'podium_integration_success',
}

export enum INTEGRATION_BC_TYPES {
  PODIUM = 'podium_oauth_success',
}

export enum INTEGRATION_TYPE {
  AUTOMOTIVE = 'automotive',
  UNIVERSAL = 'universal',
}

export interface Integration {
  key: string;
  name: string;
  imgSrc?: string;
  productFeatureId?: number;
  thumbnail?: string;
  videoSource?: string;
  show: INTEGRATION_TYPE[];
  categories: string[];
  description: IntegrationDescription;
}

export type IntegrationDescription = {
  paragraphs: string[];
  links?: Record<string, string>;
};

export interface IntegrationProps {
  key: string;
  name: string;
  categories: string[];
  description: IntegrationDescription;
  i18nBaseKey: string;
  path: string;
  component:
    | React.ComponentType<any>
    | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>;
  imgSrc: string;
  productFeatureId?: number;
  enabled?: boolean;
  thumbnail?: string;
  videoSource?: string;
  actionButton?: JSX.Element;
  onClick?: any;
  automotiveHidden?: boolean;
  show: INTEGRATION_TYPE[];
}
